import { render, staticRenderFns } from "./AuthSnackbar.vue?vue&type=template&id=3892d3a9"
import script from "./AuthSnackbar.vue?vue&type=script&lang=js"
export * from "./AuthSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports